import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useCallback, useState } from "react";

function useConfirm() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOptions, setDialogOptions] = useState({
    title: "",
    content: "",
    onConfirm: null,
  });

  const openConfirmDialog = useCallback((title, content, onConfirm) => {
    setDialogOptions({ title, content, onConfirm });
    setIsOpen(true);
  }, []);

  const closeDialog = () => {
    setIsOpen(false);
    setDialogOptions({ title: "", content: "", onConfirm: null });
  };

  const handleConfirm = () => {
    if (dialogOptions.onConfirm) dialogOptions.onConfirm();
    closeDialog();
  };

  const DialogComponent = () => (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
        },
      }}
      slotProps={{
        root: {
          className: "portrait-dialog",
        },
      }}
    >
      <DialogTitle>{dialogOptions.title}</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flex: isMobile ? "1 1 auto" : undefined,
          minHeight: 0,
        }}
      >
        {dialogOptions.content}
      </DialogContent>
      <DialogActions sx={{ flexShrink: 0 }}>
        <Button onClick={handleConfirm} color="primary">
          Oui
        </Button>
        <Button onClick={closeDialog} color="secondary">
          Non
        </Button>
      </DialogActions>
    </Dialog>
  );

  return { openConfirmDialog, DialogComponent };
}

export default useConfirm;
